module.exports = __webpack_public_path__ + "static/img/productBg3.4eb9604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productBg3.png
// module id = GU8S
// module chunks = 0